module.exports = __webpack_public_path__ + "static/img/myqzh5.b84818e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/myqzh5.png
// module id = jM7H
// module chunks = 0